// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-1VDum","inputs":"inputs-3H31o","action":"action-20s3K"};